export default "__VITE_ASSET__Bqo4Ck_m__"